import { DEFAULT_PAGE_SIZE } from "../../constants/pagination";
import { BUSINESS } from "./actionTypes";

const INIT_STATE = {
  listaBusiness: {
    totalRecords: 0,
    records: [],
  },
  loadingBusiness: true,
  filterBusiness: null,
  business: null,
  messageBusiness: null,
  isBusinessSave: null,
  pageSizeBusiness: DEFAULT_PAGE_SIZE,
  errorLoadingBusiness: null,
};

const BusinessReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case BUSINESS.GET_LISTA_BUSINESS.REQUEST:
      return {
        ...state,
        filterBusiness: action.payload,
        loadingBusiness: true,
      };

    case BUSINESS.GET_LISTA_BUSINESS.SUCCESS:
      return {
        ...state,
        listaBusiness: action.payload,
        loadingBusiness: false,
      };

    case BUSINESS.GET_LISTA_BUSINESS.FAIL:
      return {
        ...state,
        messageBusiness: action.payload,
        loadingBusiness: false,
      };
    case BUSINESS.GET_BUSINESS.REQUEST:
      return {
        ...state,
        loadingBusiness: true,
      };

    case BUSINESS.GET_BUSINESS.SUCCESS:
      return {
        ...state,
        business: action.payload,
        loadingBusiness: false,
      };

    case BUSINESS.GET_BUSINESS.FAIL:
      return {
        ...state,
        messageBusiness: action.payload,
        loadingBusiness: false,
        errorLoadingBusiness: true,
      };
    case BUSINESS.SAVE_BUSINESS.REQUEST:
      return {
        loadingBusiness: true,
        ...state,
      };

    case BUSINESS.SAVE_BUSINESS.SUCCESS:
      return {
        ...state,
        loadingBusiness: false,
        isBusinessSave: action.payload,
      };

    case BUSINESS.SAVE_BUSINESS.FAIL:
      return {
        ...state,
        loadingBusiness: false,
        messageBusiness: action.payload,
        isBusinessSave: false,
      };

    case BUSINESS.LOAD_EMPTY_BUSINESS:
      return {
        ...state,
        loadingBusiness: false,
        business: null,
        errorLoadingBusiness: null,
      };

    case BUSINESS.CLEAN_MESSAGE_BUSINESS:
      return {
        ...state,
        messageBusiness: null,
        isBusinessSave: null,
        loadingBusiness: false,
      };

    case BUSINESS.CHANGE_PAGE_SIZE_BUSINESS:
      return {
        ...state,
        pageSizeBusiness: action.payload,
      };

    default:
      return state;
  }
};

export default BusinessReducer;
